// extracted by mini-css-extract-plugin
module.exports = {"content":"SnaiScoreboard_content__BgSVx","hidden":"SnaiScoreboard_hidden__OAeRq","visible":"SnaiScoreboard_visible__gyK_T"};